import React, { useEffect } from 'react'
import { useBindingInfoAPI } from '../../components/BindingInfoHook/useBindingInfoAPI'

const MiddleScreenInZalo = () => {
    const bindingInfo = useBindingInfoAPI();
    const { app_id: appid, binding_token: token, is_legacy } = bindingInfo || {}

    useEffect(() => {
        if (appid) {
            let url = `${window.runtime_configs.REACT_APP_AGREEMENT_AUTHORIZE_URL}${token}&source=webinzalo`;
            if(is_legacy) {
                url = `${window.runtime_configs.REACT_APP_ZPI_SCREEN}/agreement-pay/binding-info?c=1&appid=${appid}&token=${token}&source=webinzalo`;
            }
            console.log(url);
            window.location.replace(url)
        }
    }, [appid, token])

    return <React.Fragment></React.Fragment>
}

export default MiddleScreenInZalo
